import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

/* Bootstrap first: the screens use its grid, and design/screens.css
   re-skins its components at equal specificity from there. */
import 'bootstrap/dist/css/bootstrap.min.css';

import './design/tokens.css';
import './design/shell.css';
import './design/screens.css';
import './design/modules.css';
import './design/cameras.css';
import './design/access.css';
import './design/actions.css';
import './design/keyboard.css';

import Home from "./pages/home.js";
import NotFound from "./pages/404.js";

/* Both routes are imported eagerly. This is a kiosk on a wall: it boots
   once and stays open, so splitting the only two screens it has into
   separate chunks bought a spinner on first paint and nothing else. */
function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
